// src/taskpane/index.tsx
import * as React from "react";
import { createRoot } from "react-dom/client";
import {
  FluentProvider,
  webLightTheme,
  webDarkTheme,
} from "@fluentui/react-components";
import App from "./components/App";
import "./components/App.css";

/* Office.js 初始化 */
const OfficeJS = window.Office;

OfficeJS.onReady(() => {
  const rootElement = document.getElementById("container");
  if (!rootElement) return;

  const root = createRoot(rootElement);

  // 检测 Office 主题
  const isDark = OfficeJS.context?.officeTheme?.bodyBackgroundColor
    ? isDarkColor(OfficeJS.context.officeTheme.bodyBackgroundColor)
    : false;

  root.render(
    <FluentProvider theme={isDark ? webDarkTheme : webLightTheme}>
      <App />
    </FluentProvider>
  );

  // 监听主题变化（防御性检查，部分环境可能不支持）
  try {
    if (OfficeJS.context?.ui?.addHandlerAsync) {
      OfficeJS.context.ui.addHandlerAsync(
        Office.EventType.OfficeThemeChanged,
        () => {
          // 简单方案：刷新页面以应用新主题
        }
      );
    }
  } catch {
    // 忽略主题监听错误
  }
});

function isDarkColor(bgColor: string): boolean {
  const hex = bgColor.replace("#", "");
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance < 0.5;
}
